import { remoteStorageApi } from '@mathflat/domain/RemoteStorage'
import { makeAutoObservable } from 'mobx'

type RemoteStorageItem = {
  curriculumKey: string | null
  isVisitedSelfLearning: boolean
  isCompletedSelfLearning: boolean
}

class RemoteStorageService implements RemoteStorageItem {
  private relationId: string | null = null
  curriculumKey: string | null = null
  isVisitedSelfLearning: boolean = false
  isCompletedSelfLearning: boolean = false
  isCompletedInitialStudentInfoSetting: boolean = false // B2G 학생 학교급, 학년 설정 완료 여부

  constructor() {
    makeAutoObservable(this)
  }

  get isReady() {
    return !!this.relationId
  }

  initRelationId = (relationId) => {
    if (!relationId) return

    this.relationId = relationId
  }

  get = async (...keys: string[]) => {
    const { relationId } = this
    if (!relationId) {
      return
    }

    const data = await remoteStorageApi.getRemoteStorageValues(relationId, keys)

    for (const [k, v] of Object.entries(data)) {
      this._set(k, v)
    }

    // return data as Record<K, RemoteStorageItem[K]>
    return data
  }

  // ** 주의 **
  // write 후에 바로 최신 데이터 read가 필요한 경우에만 사용해야 함.
  // 정확한 최신 데이터를 보장할 수 있으나 조회 비용이 높음.(2배)
  //
  // consistentGet = async (...keys: string[]) => {
  //   if (!this.isReady) {
  //     return
  //   }

  //   const { data } = await remoteStorageAxios.get(
  //     `/storage/${this.relationId}?consistentRead=true`,
  //     {
  //       params: {
  //         keys: keys.join(','),
  //       },
  //     },
  //   )

  //   for (const [k, v] of Object.entries(data)) {
  //     this._set(k, v)
  //   }

  //   // return data as Record<K, RemoteStorageItem[K]>
  //   return data
  // }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _set = (k: string, v: any) => {
    this[k] = v
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch = async (k: string, v: any) => {
    const { relationId } = this
    if (!relationId) {
      return
    }

    remoteStorageApi.updateRemoteStorageValues(relationId, { [k]: v }).then(() => {
      this._set(k, v)
    })
  }
}

export const remoteStorageService = new RemoteStorageService()

globalThis.remoteStorageService = remoteStorageService
